import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Button } from '../components/Button';
interface Product {
  name: string;
  price: string;
  image: string;
  hasConfigurator?: boolean;
  href?: string;
}
export function Gen3Page() {
  const products: Product[] = [{
    name: 'Gen3-PSS-Gloves USAT',
    price: '$69.00',
    image: 'https://cdn.magicpatterns.com/uploads/niYhHZHhKrMG2frXtC3Vmj/Gen3_PSS-Gloves_USAT.png',
    hasConfigurator: true
  }, {
    name: 'Gen3 E-Foot Gear',
    price: '$110.84',
    image: 'https://cdn.magicpatterns.com/uploads/cViGkDXcDmPVipYt9uyQmt/Gen3_E-Foot_Gear.jpg',
    hasConfigurator: true,
    href: '#product-gen3-efoot'
  }, {
    name: 'Gen3 Transmitter TK-Strike (Head)',
    price: '$556.85',
    image: 'https://cdn.magicpatterns.com/uploads/32CSZRc127TCj3au4ThHui/GEN3_TRANSMITTER_TK-STRIKE_(HEAD).webp',
    hasConfigurator: false
  }, {
    name: 'Gen3 Transmitter TK-Strike (Body)',
    price: '$459.35',
    image: 'https://cdn.magicpatterns.com/uploads/1ih3djYezzVq8985HX8oSL/GEN3_TRANSMITTER_TK-STRIKE_(BODY).webp',
    hasConfigurator: false
  }, {
    name: 'TK-Strike Gen3 Receiver',
    price: '$688.34',
    image: 'https://cdn.magicpatterns.com/uploads/55DtFd96dsvi8vp6TjTcGE/TK-STRIKE_GEN3_RECEIVER.webp',
    hasConfigurator: false
  }, {
    name: 'Gen3 Electronic Body Protector',
    price: '$847.22',
    image: 'https://cdn.magicpatterns.com/uploads/nf6K7oc2o7k9Lq2qdDp2cD/Red-GEN3_ELECTRONIC_BODY_PROTECTOR.webp',
    hasConfigurator: true
  }, {
    name: 'Gen3 E-Head Gear',
    price: '$399.99',
    image: 'https://cdn.magicpatterns.com/uploads/pZymF2e8PGGmiMTnD1QNCR/Red-and-BlueGEN3_E-HEAD_GEAR.webp',
    hasConfigurator: true
  }, {
    name: 'Gen 3 Software Download',
    price: '$99.99',
    image: 'https://cdn.magicpatterns.com/uploads/uzhJjiwifSbakuQBq1HFz4/Gen3_Software_download.png',
    hasConfigurator: false
  }];
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-824">
      <Header data-id="element-825" />

      <main className="flex-grow pt-32 pb-20" data-id="element-826">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-827">
          {/* Page Header */}
          <div className="text-center mb-12" data-id="element-828">
            <h1 className="text-4xl font-black text-gray-900 uppercase tracking-tight mb-4" data-id="element-829">
              <span className="text-red-600" data-id="element-830">GEN 3</span>
            </h1>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto" data-id="element-831">
              The newest generation of Daedo electronic scoring gear. Upgrade
              your equipment for the most accurate scoring experience.
            </p>
          </div>

          {/* Products Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-832">
            {products.map((product, index) => <div key={index} className="flex items-start gap-6 p-6 bg-white border border-gray-200 rounded-lg hover:shadow-md transition-shadow" data-id="element-833">
                {/* Product Image */}
                <a href="#product-gen3-efoot" className="flex-shrink-0 w-24 h-24 bg-gray-100 rounded-lg flex items-center justify-center overflow-hidden hover:opacity-80 transition-opacity" data-id="element-834">
                  <img src={product.image} alt={product.name} className="w-full h-full object-contain" data-id="element-835" />
                </a>

                {/* Product Details */}
                <div className="flex-grow" data-id="element-836">
                  <span className="text-xs text-blue-600 font-semibold uppercase tracking-wider" data-id="element-837">
                    Gen 3
                  </span>
                  <a href="#product-gen3-efoot" data-id="element-838">
                    <h3 className="text-lg font-bold text-gray-900 mb-2 hover:text-red-600 transition-colors" data-id="element-839">
                      {product.name}
                    </h3>
                  </a>
                  <div className="mb-4" data-id="element-840">
                    <span className="text-sm text-gray-600 font-semibold" data-id="element-841">
                      Your Price
                    </span>
                    <p className="text-2xl font-black text-gray-900" data-id="element-842">
                      {product.price}
                    </p>
                  </div>

                  <div className="flex items-center gap-3" data-id="element-843">
                    <div className="flex items-center gap-2" data-id="element-844">
                      <label htmlFor={`qty-${index}`} className="text-sm font-bold text-gray-700" data-id="element-845">
                        Qty
                      </label>
                      <input type="number" id={`qty-${index}`} defaultValue="1" min="1" className="w-16 px-2 py-1 border border-gray-300 rounded text-center focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-846" />
                    </div>
                    <a href="#product-gen3-efoot" data-id="element-847">
                      {product.hasConfigurator ? <Button variant="primary" className="!py-2 !px-4 text-sm" data-id="element-848">
                          Select Options
                        </Button> : <Button variant="primary" className="!py-2 !px-4 text-sm bg-red-600 hover:bg-red-700 focus:ring-red-600" data-id="element-849">
                          Add To Cart
                        </Button>}
                    </a>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </main>

      <Footer data-id="element-850" />
    </div>;
}